<template>
  <div>
    <div class="box">
      <Left class="left" :id="$route.params.type" />
      <div class="article">
        <div class="title">{{ article.basicTitle }}</div>
        <div class="data">
          <span class="time">发布时间：{{ article.basicUpdatetime }}</span>
          <span class="read">阅读次数：{{ article.basicHit }}</span>
        </div>
        <div class="content" v-html="html"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Left from "@/components/Left.vue";
export default {
  components: {
    Left
  },
  data() {
    return {
      article: {},
      html: ""
    };
  },
  created() {
    this.getNewsList();
  },
  watch: {
    $route(to, from) {
      this.getNewsList();
    }
  },
  methods: {
    ...mapActions(["getArticle"]),
    getNewsList() {
      this.getArticle(this.$route.params.id).then(res => {
        this.article = res.data;
        let html = res.data.articleContent.replace(
          /href="\.\.\/images/g,
          'target="_blank" href="' + this.$store.state.baseUrl + 'images'
        );
        html = html.replace(
          /src="http/g,
          ' style="width:16px;height:16px;" ' + 'src="http'
        );
        html = html.replace(
          /src="images/g,
          'src="' + this.$store.state.baseUrl + 'images'
        );
        this.html = html.replace(
          /src="\/utf8/g,
          'src="' + this.$store.state.baseUrl + 'utf8'
        );
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  display: flex;
}
.left {
  width: 20%;
}
.article {
  width: 80%;
  padding: 20px;
  .title {
    font-size: 18px;
    height: 50px;
    line-height: 50px;
    border-bottom: solid 1px #eee;
    text-align: center;
  }
  .data {
    height: 30px;
    line-height: 30px;
    border-bottom: solid 1px #eee;
    color: #595757;
    text-align: center;
    font-size: 14px;
    .read {
      margin-left: 20px;
    }
  }
}

.banner {
  width: 100%;
}
</style>
